<template>
	<touch-app-shell v-if="env.touch" :search="search" :notification="notification" :theme="theme"></touch-app-shell>
	<mouse-app-shell v-else :search="search" :notification="notification" :theme="theme"></mouse-app-shell>
</template>

<script setup lang="ts">
import MouseAppShell from "./mouse/MouseAppShell.vue";
import TouchAppShell from "./touch/TouchAppShell.vue";
import {injectEnv} from "../fd/Environment";
import type {ShellProps} from "./ShellProps";

const props = withDefaults(defineProps<ShellProps>(), {
	search: false,
	notification: false,
	theme: true,
	file: ""
});

const env = injectEnv();
</script>

<style>
</style>
